import { render, staticRenderFns } from "./NxLogin.vue?vue&type=template&id=0c805f4c&scoped=true&"
import script from "./NxLogin.vue?vue&type=script&lang=js&"
export * from "./NxLogin.vue?vue&type=script&lang=js&"
import style0 from "./NxLogin.vue?vue&type=style&index=0&id=0c805f4c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c805f4c",
  null
  
)

export default component.exports